<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="查询"
      permpisionsQuery
    >
      <section slot="belongCity" slot-scope="prop">
        <ChooseAddress
          :showCloseBtn="true"
          :showCleanBtn="true"
          :selectType="2"
          placeholder="请选择归属城市"
          v-model="prop.form.belongCity"
        />
      </section>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  selectSysStaticDataByCodeType,
} from 'api';
import ChooseAddress from 'components/chooseAddress/chooseAddress';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
    ChooseAddress,
  },
  data () {
    return {
      searchBoxData: {
        addressTypeOptions: [],
        form: [
          {
            label: '地址类型',
            value: 'addressType',
            type: 'select',
            default: '-1',
          },
          {
            label: '客户名称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          {
            label: '收货方',
            value: 'consignee',
            type: 'input',
            placeholder: '请输入收货方',
          },
          {
            label: '归属城市',
            value: 'belongCity',
            slot: true,
            default: [],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.belongCity && searchBoxData.belongCity.length) {
        if (searchBoxData.belongCity[0]) {
          searchBoxData.provinceId = `${searchBoxData.belongCity[0]}`;
        }
        if (searchBoxData.belongCity[1]) {
          searchBoxData.cityId = `${searchBoxData.belongCity[1]}`;
        }
        delete searchBoxData.belongCity;
      }
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
      });
    },
  },
  async created () {
    const addressTypeOptions = await selectSysStaticDataByCodeType({
      codeType: 'CITY_ADDRESS_TYPE',
      hasAll: true,
    });
    this.searchBoxData.addressTypeOptions = addressTypeOptions;
  },
};
</script>

<style lang="scss" scoped>
</style>
